export default {
    text1: 'class(es)',
    text2: '%',
    text3: 'set(s)',
    text4: 'time(s)',
    text5: 'min(s)',
    text6: 'msg(s)',
    text7: 'unit(s)',
    text8: 'm',
  }